import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      &:active {\n        box-shadow: ", ";\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      &:hover {\n        box-shadow: ", ";\n      }\n      &:focus {\n        box-shadow: ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  box-shadow: ", ";\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { SHADOW_DEFAULT, SHADOW_FOCUSED } from '../../shadows';
export var buttonBoxShadowMixin = css(_templateObject(), function (_ref) {
  var disabled = _ref.disabled,
      inactive = _ref.inactive,
      noShadow = _ref.noShadow,
      noShadowDisabled = _ref.noShadowDisabled;
  return (
    /* prettier-ignore */
    disabled && !inactive ? noShadowDisabled ? 'none' : SHADOW_DEFAULT : noShadow ? 'none' : SHADOW_DEFAULT
  );
}, function (_ref2) {
  var inactive = _ref2.inactive,
      disabled = _ref2.disabled,
      $hasTouch = _ref2.$hasTouch,
      noShadowHover = _ref2.noShadowHover,
      noShadowFocus = _ref2.noShadowFocus;
  return !inactive && !disabled && !$hasTouch && css(_templateObject2(), noShadowHover ? 'none' : SHADOW_FOCUSED, noShadowFocus ? 'none' : SHADOW_FOCUSED);
}, function (_ref3) {
  var inactive = _ref3.inactive,
      disabled = _ref3.disabled,
      noShadowActive = _ref3.noShadowActive;
  return !inactive && !disabled && css(_templateObject3(), noShadowActive ? 'none' : SHADOW_FOCUSED);
});
export var buttonBoxShadowKeys = ['noShadow', 'noShadowActive', 'noShadowHover', 'noShadowFocus', 'noShadowDisabled'];